import { faCheck, faSignInAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSignUp } from '../../Auth/Hooks/useSignUp';
import { SignUpForm } from '../../Auth/Components/SignUpForm';
import { useAuth } from '../../../Contexts/AuthProvider';

/**
 * Sign up page under the home section.
 */
export const SignUp = () => {
  const navigate = useNavigate();
  const { loginWithTokens } = useAuth();

  const { handleSubmit, error } = useSignUp({
    onSuccess: (response) => {
      loginWithTokens({ accessToken: response.access_token, expiry: response.expiry }).then(
        (user) => {
          navigate('/agent');
        }
      );
    },
  });

  return (
    <>
      <Helmet>
        <title>Log In</title>
      </Helmet>
      <div className="intro mb-5">
        <Container className="max-w-xl pt-5 pb-5">
          <Row className="pt-2 mt-5">
            <Col lg={5} className="pt-2">
              <h1 className="fw-bold mt-5 text-white">Try it out!</h1>
              <p className="text-white lead">
                You'll have 30 days to try out MedicarePRO with full access to all of it's features.
                If you like it and want to keep using it - fantastic!
              </p>
              <h5 className="fw-bold mt-3 text-white">Already have an account?</h5>
              <NavLink className="btn btn-primary mt-1" to="/home/log-in" end>
                Log In
              </NavLink>
            </Col>
            <Col lg={7}>
              <Card className="border bg-white">
                <div className="card-icon">
                  <FontAwesomeIcon icon={faSignInAlt} />
                </div>
                <Card.Body className="p-4">
                  <SignUpForm onSubmit={handleSubmit} errorMessage={error ?? undefined} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
